export class ExternalPromise {
	protected promise:Promise<void>;
	protected resolver: (value?) => void;
	protected rejecter: (reason?) => void;

	constructor(){
		this.promise = new Promise<void>((resolve, reject) => {
			// assign protected methods to promise callback
			this.resolver = resolve;
			this.rejecter = reject;
		});
	}

	/**
	 * Resolve promise extrenally
	 */
	resolve(value?){
		this.resolver(value);
	}

	/**
	 * Reject promise externally
	 */
	reject(reason?){
		this.rejecter(reason);
	}

	then(resolve, reject):Promise<void>{
		return this.promise.then(resolve, reject);
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/utils/ExternalPromise.ts